import { useEffect } from 'react';
import { haptic } from '../haptic';

/** Fires a 3ms vibrate on every button/link click. Loud explicit haptics (success/error) still win
 * when they fire later in the same handler — the vibrate API supersedes any prior buzz. */
export default function GlobalHaptics() {
  useEffect(() => {
    function onClick(e: MouseEvent) {
      if (!e.isTrusted) return; // ignore synthetic .click() events — defends against recursion through haptic fallbacks
      const target = e.target;
      if (!(target instanceof Element)) return;
      const hit = target.closest('button, a[href], [role="button"], label, input[type="submit"], input[type="button"], input[type="checkbox"], input[type="radio"]') as HTMLElement | null;
      if (!hit) return;
      if (hit.hasAttribute('disabled') || hit.getAttribute('aria-disabled') === 'true') return;
      haptic.light();
    }
    document.addEventListener('click', onClick, { capture: true, passive: true });
    return () => document.removeEventListener('click', onClick, { capture: true });
  }, []);
  return null;
}
